"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const scale_1 = require("../../utils/scale");
const CustomText_1 = __importDefault(require("../text/CustomText"));
const CustomTabBar = (props) => {
    const { state, descriptors, navigation } = props;
    return ((react_1.default.createElement(react_native_1.View, { style: styles.tabContainer },
        state.routes.map((route, index) => {
            const { options } = descriptors[route.key];
            const isFocused = state.index === index;
            const label = options.tabBarLabel !== undefined
                ? options.tabBarLabel
                : route.name;
            return (react_1.default.createElement(react_native_1.Pressable, { key: index, onPress: () => navigation.navigate(route.name), style: styles.tabItem },
                react_1.default.createElement(CustomText_1.default, { weight: isFocused ? "600" : "300", style: [
                        styles.tabItemLabel,
                        { color: isFocused ? "#007AFF" : "#888888" },
                    ] }, label),
                react_1.default.createElement(react_native_1.View, { style: [styles.tabItemIndicator, {
                            backgroundColor: isFocused ? '#007AFF' : "#DDDDDD",
                        }] })));
        }),
        react_1.default.createElement(react_native_1.View, { style: styles.tabIndicator }))));
};
exports.default = CustomTabBar;
const styles = react_native_1.StyleSheet.create({
    tabContainer: {
        position: 'relative',
        paddingHorizontal: (0, scale_1.scale)(16),
        paddingBottom: (0, scale_1.scale)(12),
        marginTop: (0, scale_1.scale)(24),
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: 'transparent'
    },
    tabItem: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1,
    },
    tabItemLabel: {
        color: '#888888',
        paddingBottom: (0, scale_1.scale)(8),
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
    },
    tabItemIndicator: {
        width: "100%",
        height: (0, scale_1.scale)(4),
        borderRadius: 99,
    },
    tabIndicator: {
        position: 'absolute',
        bottom: (0, scale_1.scale)(12),
        left: (0, scale_1.scale)(16),
        right: (0, scale_1.scale)(16),
        height: (0, scale_1.scale)(4),
        borderRadius: 99,
        backgroundColor: '#DDDDDD',
        zIndex: 0,
    }
});
